var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{ref:"campo",attrs:{"value":_vm.texto,"disabled":_vm.disabled,"size":"mini"},on:{"blur":_vm.onBlur},nativeOn:{"keydown":function($event){return _vm.onKeydown.apply(null, arguments)},"paste":function($event){return _vm.onPaste.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }